import React from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ModalDelete = (props) => {
  const { t } = useTranslation();
  const { image, show, handleClose, handleSubmitData } = props;

  const confirmerSuppression = async () => {
    handleSubmitData("delete");
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminStyle.modalDeleteTitre")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Image src={image} style={{ width: "100%" }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.enregistrer")}
        </Button>
        <Button variant="success" onClick={confirmerSuppression}>
          {t("commun.form.button.confirmSuppression")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
